import {useState} from "react"
import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";
import { minutes } from "@/utils";

const useTradePerformanceQueryKey = ["performance"] as any;
const TIMEFRAMES = ["day", "week", "month", "year"];
export const useTradePerformance = () => {
  const { user, getToken } = useAuth();
  const email = user?.email;
    const [timeframe, setTimeframe] = useState<"day" | "week" | "month" | "year">(
      "day"
    );

  const getTradePerformance = async () => {
    try {
      const token = await getToken();
      const res = await authorizedAxios(token).get(
        `/positions/performance?timeframe=${timeframe || "day"}`
      );
      return res.data;
    } catch (error) {
      console.log("[useGetAssets] error", error);
      throw error;
    }
  };
  const queryKey = [...useTradePerformanceQueryKey, timeframe];

  const {
    isLoading: isQueryLoading,
    isIdle,
    isSuccess,
    error,
    isError,
    data,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: getTradePerformance,
    enabled: !!email,
    refetchOnWindowFocus: false,
    staleTime: 5 * minutes,
  });
  return {
    isQueryLoading,
    isIdle,
    error,
    tradePerformance: data,
    refetch,
    timeframe,
    setTimeframe,
    TIMEFRAMES
  };
};
